import * as React from 'react';

import esteeLauderVariant1 from '../assets/esteeLauder/esteVariant1.webp';
import esteeLauderVariant2 from '../assets/esteeLauder/esteVariant2.webp';
import larocheVariant1 from '../assets/laRoche/larocheVariant1.webp';
import larocheVariant2 from '../assets/laRoche/larocheVariant2.webp';
import { useSkinAnalyzerVisibility } from '../hooks/useAnalyzerVisibility';
import { useBrand } from '../hooks/useBrand';
import { ImageVariant1, ImageVariant2 } from '../styled';

const getImageComponent = (
  isVariant1: boolean,
  variant1Src: string,
  variant2Src: string
) => {
  return isVariant1 ? (
    <ImageVariant1 src={variant1Src} alt="skin analyser image" />
  ) : (
    <ImageVariant2 src={variant2Src} alt="skin analyser image" />
  );
};

export const Images = () => {
  const { isEstee, isLaRoche } = useBrand();
  const { isVariant1 } = useSkinAnalyzerVisibility();

  const larocheImage = getImageComponent(
    isVariant1,
    larocheVariant1,
    larocheVariant2
  );

  const esteeLauderImage = getImageComponent(
    isVariant1,
    esteeLauderVariant1,
    esteeLauderVariant2
  );

  return (
    <>
      {isLaRoche && larocheImage}
      {isEstee && esteeLauderImage}
    </>
  );
};
